export default __webpack_public_path__ + "static/media/reconn.c1d5ff5b.gif";